import { render, staticRenderFns } from "./CorporateTablesV4.vue?vue&type=template&id=4c762657&scoped=true"
import script from "./CorporateTablesV4.vue?vue&type=script&lang=js"
export * from "./CorporateTablesV4.vue?vue&type=script&lang=js"
import style0 from "./CorporateTablesV4.vue?vue&type=style&index=0&id=4c762657&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c762657",
  null
  
)

export default component.exports